/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { Grid, Typography } from '@statsbomb/kitbag-components';
import { isEmpty, isEqual } from 'lodash';
import {
  FixedAside,
  FixedAsideContent,
  GridBackground,
  KitbagPageGridHolder,
} from '../../../components/Layout/Layout.styles';
import Tile from '../../../components/Tile/Tile';
import MetricModal from './MetricModal/MetricModal';
import MetricFilters from './MetricFilters/MetricFilters';
import { useGetPlayerStatDefinitions } from '../../../utils/hooks/useGetPlayerStatDefinitions';
import ScoutPlayers from './ScoutPlayers/ScoutPlayers';
import PositionFilter from '../../../components/PositionFilter/PositionFilter';
import BiometricFilters from './BiometricFilters/BiometricFilters';
import TransferPortalToggle from './BiometricFilters/toggles/TransferPortalToggle';
import PlaysSlider from './PlaysSlider/PlaysSlider';
import {
  ScoutSidebarWrapper,
  ScoutTabGeneralWrapper,
} from './ScoutResults.styles';
import ScoutTemplateManagement from './ScoutTemplateManagement/ScoutTemplateManagement';
import { useStore } from '../../../store/useStore';
import ScoutFavouritesToggle from './Favourites/ScoutFavouritesToggle';
import {
  SummaryTile,
  SummaryTileBody,
} from '../../../components/Tile/TileSummary.styles';
import { ScoutTabs } from './ScoutTabs/ScoutTabs';

const ScoutResults = () => {
  const selectedPositions = useStore((s) => s.selectedPositions);
  const setSelectedPositions = useStore((s) => s.setSelectedPositions);
  const setStatDefinitions = useStore((s) => s.setStatDefinitions);
  const statDefinitions = useStore((s) => s.statDefinitions);
  const scoutTabIndex = useStore((s) => s.scoutTabIndex);

  const { statDefinitions: statDefinitionsSource, statDefinitionLoading } =
    useGetPlayerStatDefinitions();

  useEffect(() => {
    // Set the stat definitions in the store when they are loaded
    if (
      !statDefinitionLoading &&
      !isEmpty(statDefinitionsSource) &&
      !isEqual(statDefinitionsSource, statDefinitions)
    ) {
      setStatDefinitions(statDefinitionsSource);
    }
  }, [statDefinitionsSource, setStatDefinitions, statDefinitionLoading]);

  return (
    <>
      <KitbagPageGridHolder>
        <Grid container={false} page>
          <FixedAside
            $width="320px"
            $padding="1rem 0 3.5rem 0"
            $paddingTopMD="1rem"
          >
            <GridBackground>
              <ScoutSidebarWrapper>
                <ScoutTemplateManagement />
                <ScoutTabs />
                <SummaryTile $display={scoutTabIndex === 0 ? 'flex' : 'none'}>
                  <SummaryTileBody>
                    <ScoutTabGeneralWrapper>
                      <div>
                        <Typography variant="headingSmall">
                          Positions
                        </Typography>
                        <PositionFilter
                          selectedPositions={selectedPositions}
                          setSelectedPositions={setSelectedPositions}
                          isRosterPositions
                          showTitle={false}
                        />
                      </div>
                      <PlaysSlider />
                      <TransferPortalToggle />
                      <ScoutFavouritesToggle />
                    </ScoutTabGeneralWrapper>
                  </SummaryTileBody>
                </SummaryTile>

                <SummaryTile $display={scoutTabIndex === 1 ? 'flex' : 'none'}>
                  <SummaryTileBody
                    $overflowY="visible"
                    $overflowX="visible"
                    $padding="0 0 5rem 0"
                  >
                    <BiometricFilters />
                  </SummaryTileBody>
                </SummaryTile>

                <SummaryTile $display={scoutTabIndex === 2 ? 'flex' : 'none'}>
                  <SummaryTileBody>
                    <MetricModal />
                    <MetricFilters />
                  </SummaryTileBody>
                </SummaryTile>
              </ScoutSidebarWrapper>
            </GridBackground>
          </FixedAside>
          <FixedAsideContent
            $margin="0 0.5rem 0 0"
            $marginMd="0 0.5rem -3.5px 0"
            $marginMdChild="0 0 auto auto"
            $width="calc(100%)"
            $widthMd="calc(100% - 319px)"
          >
            <Grid container={false}>
              <Grid item xs={12}>
                <Tile border="0" full margin="0">
                  <Tile.Body>
                    {!isEmpty(selectedPositions) && <ScoutPlayers />}
                  </Tile.Body>
                </Tile>
              </Grid>
            </Grid>
          </FixedAsideContent>
        </Grid>
      </KitbagPageGridHolder>
    </>
  );
};

export default ScoutResults;
